import React, { Fragment } from 'react';
import { FormattedMessage } from 'react-intl';


const PopupFail = ({title="Error", props}) => {


    return (
        <Fragment>
            <div className="modal fade PopsData" id="popup-fail" tabIndex="-1" role="dialog" aria-labelledby="comment" aria-hidden="true">
                <div className="modal-dialog" role="document">
                    <div className="modal-content">
                       
                        <div className="modal-body">
                            <div className="unsucces">
                                <span className="icon">
                                <i className="fa fa-thumbs-down" aria-hidden="true"></i>
                                </span>
                                <h4>{title && title}</h4>
                                <p>{props && props}</p>
                                <button id="dismiss-modal" type="button" className="close m-0" data-dismiss="modal" aria-label="Close">
                                     <span aria-hidden="true">&times;</span>
                                </button>
                                <button id="dismiss-modal" type="button" className="closes" data-dismiss="modal" aria-label="Close">
                                     <FormattedMessage id="Ok" defaultMessage="Ok"/>!
                                </button>
                                <button style={{display:'none'}} className="btn-black active-all" id="popup-click-fail" data-toggle="modal" data-target="#popup-fail">
                                    <FormattedMessage id="pop_up" defaultMessage="pop up"/>
                                </button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </Fragment>
    )
}

export default PopupFail

